// @flow
import React, { Component } from 'react';
import 'medium-draft/lib/index.css';
import 'font-awesome/css/font-awesome.min.css';
import { get, getOr } from 'lodash/fp';
import { convertToRaw } from 'draft-js';
import mediumDraftImporter from 'medium-draft/lib/importer';
import mediumDraftExporter from 'medium-draft/lib/exporter';
import { Editor, createEditorState } from 'medium-draft';
import Disqus from 'react-disqus-comments';
import { Redirect } from 'react-router-dom';
import ProgressButton, {
  PROGRESS_STATE,
} from '../../components/button/progress';
import createUpdateProposal from './graphql/create-update-proposal';
import getProposal from './graphql/get-proposal';
import {
  ComposeWrapper,
  TitleInput,
  EditorWrapper,
  Header,
  DisqusWrapper,
} from './proposal.styles';
import EditorImageButton from './components/editor-image-button';

type Props = {
  isOpen: boolean,
};

class ProposalPage extends Component {
  state = {
    editorState: createEditorState(),
    title: '',
    progressState: PROGRESS_STATE.DISABLED,
    hasMadeEdits: false,
  };

  componentDidMount() {
    const proposal = getOr({}, 'getProposal.proposal', this.props);

    this.setState({
      title: proposal.title || '',
      editorState: proposal.content
        ? createEditorState(convertToRaw(mediumDraftImporter(proposal.content)))
        : createEditorState(),
    });
  }

  componentWillReceiveProps(nextProps: Props) {
    const proposal = get('getProposal.proposal', this.props);
    const nextProposal = get('getProposal.proposal', nextProps);
    if (nextProposal && !proposal) {
      this.setState({
        title: nextProposal.title,
        editorState: createEditorState(
          convertToRaw(mediumDraftImporter(nextProposal.content))
        ),
      });
    }
  }

  onChange = editorState =>
    this.setState({ editorState, progressState: PROGRESS_STATE.NOTHING });

  handleSubmit = async e => {
    try {
      if (this.state.progressState !== PROGRESS_STATE.NOTHING) {
        return;
      }
      e.preventDefault();
      const content = mediumDraftExporter(
        this.state.editorState.getCurrentContent()
      );
      const proposal = {
        id: get('match.params.id', this.props),
        title: this.state.title,
        content,
      };
      if (!proposal.title) window.alert('Please add a title');
      else if (!proposal.content) {
        window.alert('Please explain your proposal by adding some content');
      } else {
        this.setState({ progressState: PROGRESS_STATE.LOADING });
        const { data } = await this.props.createUpdateProposal({
          variables: proposal,
          refetchQueries: ['getFeed'],
        });
        window.mixpanel.track('New proposal', data);
        this.props.history.push(`/`);
      }
    } catch (e) {
      this.setState({ progressState: PROGRESS_STATE.ERROR });
      await new Promise(res => setTimeout(res, 2000));
      this.setState({ progressState: PROGRESS_STATE.NOTHING });
    }
  };

  props: Props;

  render() {
    const { editorState } = this.state;
    const isLoading = get('getProposal.loading', this.props);
    const proposal = get('getProposal.proposal', this.props);
    const isOwnedByUser = get('getProposal.proposal.isOwnedByUser', this.props);
    const propId = get('match.params.id', this.props);
    const isReadOnly = propId && !isOwnedByUser;
    if (propId && !isLoading && !proposal) {
      return <Redirect to="/error" />;
    }
    return (
      <ComposeWrapper>
        <Header>
          <TitleInput
            readOnly={isReadOnly}
            onChange={e =>
              this.setState({
                title: e.target.value,
                progressState: PROGRESS_STATE.NOTHING,
              })
            }
            value={this.state.title}
            placeholder="Enter a proposal title"
          />
          {!isReadOnly && (
            <ProgressButton
              controlled
              state={this.state.progressState}
              durationSuccess={2000}
              onClick={this.handleSubmit}
            >
              Save proposal
            </ProgressButton>
          )}
        </Header>
        <EditorWrapper>
          <Editor
            editorEnabled={!isReadOnly}
            placeholder="Describe your idea..."
            sideButtons={[
              {
                title: 'Image',
                component: EditorImageButton,
              },
            ]}
            editorState={editorState}
            onChange={this.onChange}
          />
          {propId ? (
            <DisqusWrapper>
              <Disqus
                shortname="munity"
                identifier={propId}
                title={this.state.title}
                url={`http://munity.planes.agency/proposal/${propId}`}
                onNewComment={this.handleNewComment}
              />
            </DisqusWrapper>
          ) : null}
        </EditorWrapper>
      </ComposeWrapper>
    );
  }
}

export default getProposal(createUpdateProposal(ProposalPage));



// WEBPACK FOOTER //
// ./src/pages/proposal/index.js